var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _vm.showFilter
                ? _c("b-col", [_c("h3", [_vm._v("Lotes")])])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showFilter
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { "align-self": "end" } },
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("De")]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: {
                          disabled: _vm.lote.length > 0,
                          config: _vm.datePickerConfig
                        },
                        model: {
                          value: _vm.fromDate,
                          callback: function($$v) {
                            _vm.fromDate = $$v
                          },
                          expression: "fromDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { "align-self": "end" } },
                    [
                      _c("label", [_vm._v("Até")]),
                      _vm._v(" "),
                      _c("date-picker", {
                        attrs: {
                          disabled: _vm.lote.length > 0,
                          config: _vm.datePickerConfig
                        },
                        model: {
                          value: _vm.toDate,
                          callback: function($$v) {
                            _vm.toDate = $$v
                          },
                          expression: "toDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.optionsStatus },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isDistribuidor
                    ? _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Classe")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { options: ["", "A", "G", "P", "L"] },
                            model: {
                              value: _vm.classe,
                              callback: function($$v) {
                                _vm.classe = $$v
                              },
                              expression: "classe"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-col", { attrs: { "align-self": "end" } }, [
                    _c("label", [_vm._v("Lote")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lote,
                          expression: "lote"
                        },
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "######",
                          expression: "'######'"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { placeholder: "Código" },
                      domProps: { value: _vm.lote },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.buscaLote.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lote = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  !_vm.isDistribuidor
                    ? _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Distribuidor")
                          ]),
                          _vm._v(" "),
                          _c("b-input", {
                            attrs: { placeholder: "Código ou Nome" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.buscaLote.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.distribuidor,
                              callback: function($$v) {
                                _vm.distribuidor = $$v
                              },
                              expression: "distribuidor"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { "align-self": "end", cols: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", disabled: _vm.loading },
                          on: { click: _vm.clickBuscaLote }
                        },
                        [
                          _c("i", { staticClass: "fas fa-search" }),
                          _vm._v(" Buscar\n                ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "secondary",
                            disabled: _vm.loading,
                            title: "Limpar Filtros"
                          },
                          on: { click: _vm.limparFiltros }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-broom fa-rotate-by",
                            staticStyle: { "--fa-rotate-angle": "-50deg" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showFilter
            ? _c(
                "b-row",
                { staticClass: "mt-3", attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { sm: "7", md: "6" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.total,
                          "per-page": _vm.perPage,
                          align: "fill",
                          size: "sm"
                        },
                        on: { input: _vm.buscaLote },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "1" } },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: _vm.optionsPerPage,
                          size: "sm",
                          title: "Por Página"
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n                Total: " +
                        _vm._s(_vm.total) +
                        "\n            "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c("b-table", {
                attrs: {
                  items: _vm.listaTabela,
                  fields: _vm.showFields,
                  "per-page": _vm.perPage,
                  stacked: "md",
                  responsive: "",
                  "empty-text": "Nenhum lote encontrado!",
                  busy: _vm.loading,
                  "show-empty": "",
                  small: "",
                  striped: "",
                  hover: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-primary my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Buscando Lotes...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(selected)",
                    fn: function(row) {
                      return [
                        row.item.status === "CANCELADO"
                          ? _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { value: row.item.id },
                              on: { click: _vm.selectLote }
                            })
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(actions)",
                    fn: function(row) {
                      return [
                        row.item.url_extrato
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-sm",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: "Fatura por Revendedora"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.getUrl(row.item.url_extrato)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-list-ol" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.item.url_resumo
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: "Resumo de Pedido"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.getUrl(row.item.url_resumo)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "far fa-file-alt" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.item.url_nfe || row.item.notas > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-warning btn-sm",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: "Nota Fiscal"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.viewNota(
                                      row.item.lote_codigo,
                                      "nota"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-file-pdf" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.item.url_devolucao || row.item.notas_devolucao
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: "Devolução"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.viewNota(
                                      row.item.lote_codigo,
                                      "devolucao"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-car" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default btn-sm",
                            attrs: {
                              type: "button",
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: "Histórico"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showHistory(row.item.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-history" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "downloadexcel",
                          {
                            staticClass: "btn btn-success btn-sm",
                            attrs: {
                              type: "xls",
                              name: _vm.filename,
                              fields: _vm.json_fields,
                              worksheet: row.item.nome,
                              title: "Lote " + row.item.lote_codigo,
                              fetch: function() {
                                return _vm.startDownload(row.item.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "far fa-file-excel" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.item.url_xml || row.item.notas,
                                expression: "row.item.url_xml || row.item.notas"
                              }
                            ],
                            staticClass: "btn btn-primary btn-sm",
                            attrs: {
                              type: "button",
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: "XML da Nota Fiscal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.viewNota(row.item.lote_codigo, "xml")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-file-archive" })]
                        ),
                        _vm._v(" "),
                        row.item.status === "TRANSPORTADORA" ||
                        row.item.status === "ENTREGUE"
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  title: "Rastreamento"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.getUrlTransp(row.item.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-truck" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isDistribuidor &&
                        _vm.showFilter &&
                        row.item.status === "CANCELADO"
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  title: "Nova numeração"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.novoNumeroLote(
                                      row.item.id,
                                      row.item.lote_codigo
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-edit" })]
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(lote_codigo)",
                    fn: function(row) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/lotes/" + row.item.lote_codigo,
                              target: "_blank"
                            }
                          },
                          [_vm._v(_vm._s(row.item.lote_codigo))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isDistribuidor && _vm.showFilter
            ? _c(
                "b-row",
                [
                  _vm.listaRecuperar.length > 0
                    ? _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-primary", size: "sm" },
                              on: { click: _vm.recuperar }
                            },
                            [
                              _c("i", { staticClass: "fas fa-recycle" }),
                              _vm._v("\n                    Recuperar")
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n                Selecionados: " +
                        _vm._s(_vm.listaRecuperar.length) +
                        "\n            "
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73fa9a32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fa9a32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/lote/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73fa9a32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/lote/List.vue
// module chunks = 2